import { GroupStatusEvent, useIM } from '@wui/im'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useRoomPublicIdentityStore = defineStore('room-public-identity', () => {
  const publicIdentityByPServedMap = ref(new Map<string, string>())
  const pServedsByPublicIdentities = ref(new Map<string, string>())

  const { onConferenceUpdated } = useIM()
  onConferenceUpdated((event: GroupStatusEvent) => {
    const { pServed } = event
    const publicIdentity = event.extendedParams?.publicIdentity
    if (!!publicIdentity) {
      const oldIdentity = publicIdentityByPServedMap.value.get(pServed)
      if (oldIdentity) {
        pServedsByPublicIdentities.value.delete(oldIdentity)
      }
      pServedsByPublicIdentities.value.set(publicIdentity, pServed)

      publicIdentityByPServedMap.value.set(pServed, publicIdentity)
    } else {
      const oldIdentity = publicIdentityByPServedMap.value.get(pServed)
      if (oldIdentity) {
        pServedsByPublicIdentities.value.delete(oldIdentity)
      }

      publicIdentityByPServedMap.value.delete(pServed)
    }
  })

  const getPublicIdentity = (pServed: string): string | undefined => publicIdentityByPServedMap.value.get(pServed)

  const getPServedByIdentity = (identity: string): string | undefined => pServedsByPublicIdentities.value.get(identity)

  return {
    getPublicIdentity,
    getPServedByIdentity,
  }
})
